<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center justify-content-between">
        <i class="icon ion-calculator"></i>
        <div class=" pd-l-20">
          <h4>{{$t("offer.报价单")}}</h4>
        </div>
      </div>
      <div class="tx-right">
         <a
         	v-if="num>0"
          href="javascript:;"
          class="btn btn-success mg-l-5"
          @click="toOffer()"
        >{{$t("offer.我要报价")}}</a> 
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-between pd-x-20 pd-sm-x-30">
      <div class="clear-key">
        <a
          v-show="distributorName"
          href="javascript:;"
          class=" mg-r-15"
          @click="clearKey('name')"
        >
          {{$t("offer.客户名：")}}
          <span class="mg-r-10">{{distributorName}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="offerStatus"
          href="javascript:;"
          class=" mg-r-15"
          @click="clearKey('status')"
        >
          {{$t("offer.状态：")}}
          <span class="mg-r-10">{{$t(dictOfferStatus[offerStatus])}}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["offerStatus", "distributorName", "distributorId","num"],
  data() {
    return {
      dictOfferStatus: arrDict.offerStatus
    };
  },
  methods: {
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    toOffer(){
      this.$emit("toOffer");
    }
  }
};
</script>

